import { useState, forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from "react";
import { SelectFromProps, SelectNoFromProps, FilmOptionType, SelectInTableNoFormprop, DeleteInTableNoFormprop, SelectInTableNoFormprop2 } from './SelectProps';
import { useFormContext, Controller } from "react-hook-form";
import { Autocomplete, TextField, FormHelperText, Popper, createFilterOptions, Tooltip, Button, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ParseHtml } from "utilities/Function";
import { useTranslation } from 'react-i18next';
import { MdDeleteForever } from "react-icons/md";

const filter = createFilterOptions<FilmOptionType>();

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const SelectFormItem = forwardRef((props: SelectFromProps, ref) => {
    const {
        name,
        fullWidth = true
    } = props;

    const {
        control,
    } = useFormContext();
    const [t] = useTranslation();
    const PopperCustom = useCallback((props) => {
        return <Popper
            {...props}
            placement='bottom'
            modifiers={[
                {
                    name: 'flip',
                    enabled: false,
                    options: {
                        altBoundary: true,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
        />;
    }, []);

    const getOpObjValue = (val) => {
        let res = null;
        if (val) res = props.options.find(op => op.value === val);
        return res;
    };
    return (
        <>

            <Controller
                name={name}
                control={control}
                render={({
                    field: { onChange, onBlur, value, ref },
                    fieldState: { invalid, error } }) => {
                    return (
                        <>
                            <Autocomplete
                                {...ref}
                                sx={{
                                    "label.MuiInputLabel-shrink": {
                                        // backgroundColor: props.disabled ? "#E9E8E8" : "#FFF",
                                        top: "0px",
                                    },
                                    ".MuiInputLabel-outlined": {
                                        top: "0px",
                                    },
                                    ".MuiInputLabel-asterisk": {
                                        color: "red"
                                    }
                                }}
                                ref={ref}
                                id={props.name}
                                disabled={props.disabled || null}
                                PopperComponent={PopperCustom}
                                fullWidth={fullWidth}
                                size={"small"}
                                options={props.options || []}
                                value={getOpObjValue(value)}
                                noOptionsText={props.notOptionsText || t("noInformationFound")}
                                disableClearable={props.isClearable || null}
                                renderOption={(props, option: any) => {
                                    return (
                                        <li {...props} key={option.value} id={option.value} style={option.color ? { backgroundColor: option.color } : {}}>
                                            {option.label}
                                        </li>
                                    );
                                }}
                                getOptionLabel={(itemOption: any) => {
                                    return `${itemOption?.label}`
                                }}
                                // isOptionEqualToValue={(option, value) =>
                                //     option.value === value.value
                                // }
                                renderInput={(params) => {
                                    let TooltipTitle = null;
                                    if (props.disabled) {
                                        TooltipTitle = params.inputProps.value;
                                    }
                                    return (
                                        <Tooltip title={ParseHtml(TooltipTitle)} disableHoverListener={TooltipTitle ? false : true} disableFocusListener>
                                            <TextField
                                                {...params}
                                                name={name}
                                                error={error?.message != null}
                                                required={props.required}
                                                disabled={props.disabled}
                                                label={props.label}
                                                size={"small"}
                                                fullWidth={fullWidth}
                                                sx={{
                                                    "label.MuiInputLabel-shrink": {
                                                        // backgroundColor: props.disabled ? "#E9E8E8" : "#FFF",
                                                        top: "0px",
                                                    },
                                                    ".MuiInputLabel-outlined": {
                                                        top: "0px",
                                                    },
                                                    ".MuiInputLabel-asterisk": {
                                                        color: "red"
                                                    }
                                                }}
                                            />
                                        </Tooltip>
                                    )
                                }
                                }
                                onChange={(event, value) => {
                                    onChange(value != null ? value["value"] : null);
                                    props.onChange && props.onChange(value, event);
                                }}
                                onBlur={(event) => {
                                    onBlur();
                                    props.onBlur && props.onBlur(event);
                                }}
                                onKeyPress={(event) => {
                                    props.onKeyPress && props.onKeyPress(event);
                                }}
                                onKeyDown={(event) => {
                                    props.onKeyDown && props.onKeyDown(event);
                                }}
                                onKeyUp={(event) => {
                                    props.onKeyPress && props.onKeyPress(event);
                                }}

                            />
                            {error ? (
                                <FormHelperText sx={{ color: "red" }}>
                                    {error.message}
                                </FormHelperText>
                            ) : null}
                        </>
                    )
                }
                }
            />

        </>
    );
});

export default SelectFormItem;

export const SelectMultipleFormItem = forwardRef((props: SelectFromProps, ref) => {
    const {
        name,
        fullWidth = true,
        limitTags = 2,
        isSelectAll = true,
    } = props;
    const {
        setValue,
        control,
    } = useFormContext();
    const [t] = useTranslation();
    const getOpObjValue = (val) => {
        let res = [];
        if (val) {
            val.forEach(element => {
                res.push(props.options.find(op => op.value === element));
            });

        }
        return res;
    };

    return (

        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, onBlur, value, ref },
                fieldState: { invalid, error } }) => {
                return (
                    <>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            ref={ref}
                            id={props.name}
                            disabled={props.disabled || null}
                            fullWidth={fullWidth}
                            size={"small"}
                            options={props.options || []}
                            groupBy={(option) => option?.gropName}
                            value={getOpObjValue(value)}
                            noOptionsText={props.notOptionsText || t("noInformationFound")}
                            disableClearable={props.isClearable || null}
                            limitTags={limitTags}
                            renderOption={(props_, option, { selected }) => {
                                let isAll = selected;
                                if (option.value === "All999") {
                                    if ((value || []).length == (props.options || []).length) {
                                        isAll = true;
                                    }
                                }
                                return (
                                    <li {...props_} key={option.value}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={option.value === "All999" ? isAll : selected}
                                            onChange={(e, v) => {
                                                if (option.value === "All999" && (!v)) {
                                                    onChange()
                                                    setValue(name, []);
                                                    props.onChange && props.onChange([], e);

                                                } else {
                                                    let val = [];
                                                    if (value) {
                                                        if (e.target.checked) {
                                                            if (option.value === "All999") {
                                                                val = props.options.map(m => m.value);
                                                            } else {
                                                                let lst: any = (value || []).filter(f => f != option.value);
                                                                lst.push(option.value);
                                                                val = lst;
                                                            }
                                                        } else {
                                                            val = (value || []).filter(f => f != option.value)
                                                        }
                                                    } else {
                                                        if (e.target.checked) {
                                                            val.push(option.value)
                                                        }
                                                    }
                                                    onChange(val);
                                                    setValue(name, val);
                                                    props.onChange && props.onChange(val, e);
                                                }
                                            }}
                                        />
                                        {option.label}
                                    </li>
                                );
                            }}

                            getOptionLabel={(itemOption: any) => {
                                return `${itemOption?.label}`
                            }}
                            filterOptions={(options, params) => {
                                const filtered = params.inputValue ? options.filter((f: any) => f.label.toLowerCase().includes(params.inputValue.toLowerCase())) : options;
                                return isSelectAll ? [{ label: "Select All", value: "All999" }, ...filtered] : filtered;
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    name={name}
                                    error={error?.message != null}
                                    required={props.required}
                                    disabled={props.disabled}
                                    label={props.label}
                                    size={"small"}
                                    fullWidth={fullWidth}
                                    sx={{
                                        "label.MuiInputLabel-shrink": {
                                            // backgroundColor: "rgb(255 255 255 / 18%)",
                                            top: "0px",
                                        },
                                        ".MuiInputLabel-outlined": {
                                            top: "0px",
                                        },
                                        ".MuiInputLabel-asterisk": {
                                            color: "red"
                                        }
                                    }}
                                />}
                            onChange={(event, selectedOptions, reason) => {
                                if (reason === "selectOption" || reason === "removeOption") {
                                    selectedOptions = selectedOptions.filter(f => f != undefined && f != null);
                                    if (selectedOptions.find(option => option.value === "All999")) {
                                        if (selectedOptions.length == 1) {
                                            const allSelected = props.options.length === (value || []).length;
                                            if (!allSelected) {
                                                setValue(name, props.options.filter(f => f.value != "All999").map(m => m.value));
                                                onChange(props.options.filter(f => f.value != "All999").map(m => m.value))
                                                props.onChange && props.onChange(props.options.filter(f => f.value != "All999").map(m => m.value), event);
                                            } else {
                                                setValue(name, selectedOptions.filter(f => f.value != "All999").map(m => m.value));
                                                onChange(selectedOptions.filter(f => f.value != "All999").map(m => m.value));
                                                props.onChange && props.onChange(selectedOptions.filter(f => f.value != "All999").map(m => m.value), event);
                                            }
                                        } else {
                                            setValue(name, []);
                                            onChange([]);
                                            props.onChange && props.onChange([], event);
                                        }

                                    } else {
                                        let arr = (selectedOptions || []).filter(f => f.value != "All999").map(m => m["value"]);
                                        setValue(name, arr || []);
                                        onChange(arr);
                                        props.onChange && props.onChange(selectedOptions.filter(f => f.value != "All999"), event);
                                    }
                                } else if (reason === "clear") {
                                    setValue(name, []);
                                    onChange([]);
                                    props.onChange && props.onChange([], event);
                                }

                            }}
                            onBlur={(event) => {
                                onBlur();
                                props.onBlur && props.onBlur(event);
                            }}
                            onKeyPress={(event) => {
                                props.onKeyPress && props.onKeyPress(event);
                            }}
                            onKeyDown={(event) => {
                                props.onKeyDown && props.onKeyDown(event);
                            }}
                            onKeyUp={(event) => {
                                props.onKeyPress && props.onKeyPress(event);
                            }}

                        />
                        {error ? (
                            <FormHelperText sx={{ color: "red" }}>
                                {error.message}
                            </FormHelperText>
                        ) : null}
                    </>
                )
            }
            }
        />
    );
});

export const SelectMultipleAddOptionsFormItem = forwardRef((props: SelectFromProps, ref) => {
    const {
        name,
        fullWidth = true,
        limitTags = 2,
        isSelectAll = true,
    } = props;
    const [options_, setoptions] = useState<any>(props.options || [])
    const {
        control,
        getValues,
        setValue
    } = useFormContext();
    const [t] = useTranslation();
    const fixedOptions = [];
    const getOpObjValue = (val) => {
        let res = [];
        if (val) {
            val.forEach(element => {
                res.push(props.options.find(op => op.value === element));
            });

        }
        return res;
    };

    const handleToggleSelectAll = (selectedOptions) => {
        const allSelected = props.options.length === (getValues(name) || []).length;
        let chkFix = (getValues(name) || []).filter(f => f == fixedOptions[0]);
        let chkData = chkFix.length > 0 ? [] : fixedOptions[0] ?? []
        if (!allSelected) {

            setValue(name, [...chkData, ...props.options.map(m => m.value)], { shouldValidate: true });
            props.onChange && props.onChange(props.options, null);
        } else {
            setValue(name, fixedOptions);
            props.onChange && props.onChange([], null);
        }
    };

    const handleChange = (event, selectedOptions, reason) => {

        let chkFix = (getValues(name) || []).filter(f => f == fixedOptions[0]);
        let chkData = chkFix.length > 0 ? [] : fixedOptions[0] ?? []
        if (reason === "selectOption" || reason === "removeOption") {
            if (selectedOptions.find(option => option?.value === "999")) {
                handleToggleSelectAll(selectedOptions);
            } else if (selectedOptions.find(option => option.value === "9999")) {
                props.options.push({ value: selectedOptions.find(option => option?.value === "9999")["newVaue"], label: selectedOptions.find(option => option?.value === "9999")["newVaue"], Isnew: true })
                let v = selectedOptions.filter(f => f?.value != "9999").map(m => m["value"]);
                let o = selectedOptions.filter(f => f?.value == "9999").map(m => m["newVaue"]);
                setValue(name, [...chkData, ...v, ...o], { shouldValidate: true })
                // setValue(name, [...chkData, ...selectedOptions.filter(f => f?.value != "9999").map(m => m["value"]), ...selectedOptions.filter(f => f?.value == "9999").map(m => m["newVaue"])], { shouldValidate: true })
                props.onChange && props.onChange(selectedOptions, event);
            } else {
                // onToggleOption && onToggleOption(selectedOptions);
                setValue(name, [...chkData, ...selectedOptions.map(m => m.value)], { shouldValidate: true })
                props.onChange && props.onChange(selectedOptions, event);
            }
        } else if (reason === "clear") {
            setValue(name, fixedOptions, { shouldValidate: true });
            props.onChange && props.onChange([], event);
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({
                field: { onChange, onBlur, value, ref },
                fieldState: { invalid, error } }) => {
                return (
                    <>
                        <Autocomplete
                            multiple
                            disableCloseOnSelect
                            ref={ref}
                            id={name}
                            disabled={props.disabled || null}
                            fullWidth={fullWidth}
                            size={"small"}
                            options={props.options || []}
                            value={getOpObjValue(value)}
                            noOptionsText={props.notOptionsText || t("noInformationFound")}
                            disableClearable={props.isClearable || null}
                            limitTags={limitTags}
                            renderOption={(props_, option, { selected }) => {
                                return (
                                    <li {...props_} key={option.value}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={((getValues(name) || []).length > 0 && option.value === "999" && props.options.length === (getValues(name) || []).length) || selected ? true : selected}
                                        />
                                        {option.label}
                                    </li>
                                );
                            }}

                            getOptionLabel={(itemOption: any) => {
                                return `${itemOption?.label}`
                            }}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);
                                if (params.inputValue !== '') {
                                    if (props.options.filter(f => f.value == params.inputValue).length == 0) {
                                        filtered.push({
                                            value: "9999",
                                            label: `Add "${params.inputValue}"`,
                                            newVaue: params.inputValue
                                        });
                                    }
                                }
                                return isSelectAll ? [{ label: "Select All", value: "999" }, ...filtered] : filtered;
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    name={name}
                                    error={error?.message != null}
                                    required={props.required}
                                    disabled={props.disabled}
                                    label={props.label}
                                    size={"small"}
                                    fullWidth={fullWidth}
                                    sx={{
                                        "label.MuiInputLabel-shrink": {
                                            // backgroundColor: "rgb(255 255 255 / 18%)",
                                            top: "0px",
                                        },
                                        ".MuiInputLabel-outlined": {
                                            top: "0px",
                                        },
                                        ".MuiInputLabel-asterisk": {
                                            color: "red"
                                        }
                                    }}
                                />}
                            onChange={handleChange}
                            onBlur={(event) => {
                                onBlur();
                                props.onBlur && props.onBlur(event);
                            }}
                            onKeyPress={(event) => {
                                props.onKeyPress && props.onKeyPress(event);
                            }}
                            onKeyDown={(event) => {
                                props.onKeyDown && props.onKeyDown(event);
                            }}
                            onKeyUp={(event) => {
                                props.onKeyPress && props.onKeyPress(event);
                            }}

                        />
                        {error ? (
                            <FormHelperText sx={{ color: "red" }}>
                                {error.message}
                            </FormHelperText>
                        ) : null}
                    </>
                )
            }
            }
        />
    );
});

export const SelectNoFormItem = forwardRef((props: SelectNoFromProps, ref) => {
    const {
        fullWidth = true
    } = props;

    const [t] = useTranslation();
    const [value, setValue] = useState<string>("");
    const [disabled, setDisabled] = useState<boolean>(false);
    const [_option, setoption] = useState<any>([]);
    const refSelect = useRef(null);

    const PopperCustom = useCallback((props) => {
        return <Popper
            {...props}
            placement='bottom'
            modifiers={[
                {
                    name: 'flip',
                    enabled: false,
                    options: {
                        altBoundary: true,
                        rootBoundary: 'document',
                        padding: 8,
                    },
                },
            ]}
        />;
    }, []);

    useImperativeHandle(ref, () => ({        
        onDisabled(val: boolean) {
            setDisabled(val);
        }, onSetValue(val) {
            setValue(val);
        }, onSetOption(val) {
            setoption(val);
        }
    }));

    useEffect(() => { setDisabled(props.disabled || false) }, [props.disabled]);
    useEffect(() => { setValue(props.value); }, [props.value]);
    useEffect(() => { setoption(props.options); }, [props.options]);
    useEffect(() => {
        if (props.onRef) {
            props.onRef(ref);
        }
    }, [ref])
    const getOpObjValue = (val) => {
        let res = null;
        if (val) res = _option.find(op => op.value === val);
        return res;
    };


    return (
        <Autocomplete
            ref={refSelect}
            id={props.id}
            disabled={disabled}
            PopperComponent={PopperCustom}
            fullWidth={fullWidth}
            size={props.size || "small"}
            options={_option || []}
            groupBy={(option) => option?.gropName}
            value={getOpObjValue(value)}
            noOptionsText={props.notOptionsText || t("noInformationFound")}
            disableClearable={!props.isClearable}
            renderOption={(props, option: any) => {
                return (
                    <li {...props} key={option.value} style={option.color ? { backgroundColor: option.color } : {}}>
                        {option.label}
                    </li>
                );
            }}
            getOptionLabel={(itemOption: any) => {
                return `${itemOption?.label}`
            }}
            isOptionEqualToValue={(option, _value) =>
                _value && option.value === _value.value
            }
            renderInput={(params) =>
                <TextField
                    {...params}
                    name={props.id}
                    disabled={disabled}
                    label={props.label}
                    size={props.size || "small"}
                    fullWidth={fullWidth}
                    sx={{
                        "label.MuiInputLabel-shrink": {
                            // backgroundColor: disabled ? "#e7e7e7" : "rgb(255 255 255 / 18%)",
                            top: "0px",
                        },
                        ".MuiInputLabel-outlined": {
                            top: "0px",
                        },
                        ".MuiInputLabel-asterisk": {
                            color: "red"
                        }
                    }}
                />}
            onChange={(event, value) => {
                setValue(value != null ? value["value"] : null)
                props.onChange && props.onChange(value, event);
            }}
            onBlur={(event) => {
                props.onBlur && props.onBlur(event);
            }}
            onKeyPress={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
            onKeyDown={(event) => {
                props.onKeyDown && props.onKeyDown(event);
            }}
            onKeyUp={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
        />
    )
});

export const SelectInTableNoForm = forwardRef((props: SelectInTableNoFormprop, ref) => {
    const {
        isButtonDelete = true,
    } = props;

    useEffect(() => {
        if (props.onRef) {
            props.onRef(ref);
        }
    }, [ref])

    return (
        <Grid container direction="row" key={"divIn-" + props.id} className="selectInTable">
            {isButtonDelete && <Grid item sm={2} md={2} lg={2} textAlign={"center"}>
                <Button id={"button-" + props.id} className={"but-" + props.id} variant="contained" color="error" style={{
                    height: "33px",
                    marginRight: "5px",
                    borderRadius: "10px",
                    minWidth: "36px",
                    boxShadow: "rgba(0, 0, 0, 0.189) 0px 5px 15px",
                    padding: "0px"
                }}
                    onClick={(e) => props.onDelete && props.onDelete(e)}
                >
                    <MdDeleteForever style={{ fontSize: "24px" }} />
                </Button>
            </Grid>}
            <Grid item sm={isButtonDelete ? 10 : 12} md={isButtonDelete ? 10 : 12} lg={isButtonDelete ? 10 : 12}>
                <SelectNoFormItem {...props} ref={ref} />
            </Grid>
        </Grid>
    );
});

export const SelectInTableNoForm2 = forwardRef((props: SelectInTableNoFormprop2, ref) => {
    const {
        isButtonDelete = true,
    } = props;

    useEffect(() => {
        if (props.onRef) {
            props.onRef(ref);
        }
    }, [ref])

    return (
        <Grid container direction="row" key={"divIn-" + props.id} className="selectInTable" spacing={1}>
            {isButtonDelete && <Grid item sm={2} md={2} lg={2} textAlign={"center"}>
                <Button id={"button-" + props.id} className={"but-" + props.id} variant="contained" color="error" style={{
                    height: "33px",
                    borderRadius: "10px",
                    minWidth: "36px",
                    boxShadow: "rgba(0, 0, 0, 0.189) 0px 5px 15px",
                    padding: "0px"
                }}
                    onClick={(e) => props.onDelete && props.onDelete(e)}
                >
                    <MdDeleteForever style={{ fontSize: "24px" }} />
                </Button>
            </Grid>}
            <Grid item sm={isButtonDelete ? 6 : 7} md={isButtonDelete ? 6 : 7} lg={isButtonDelete ? 6 : 7}>
                <SelectNoFormItem
                    id={props.id}
                    label={"- Define -"}
                    value={props.value}
                    options={props.options}
                    disabled={props.disabled}
                    onChange={(value, event) => props.onChange && props.onChange(value, event)}
                    ref={ref}
                />
            </Grid>
            <Grid item sm={isButtonDelete ? 4 : 5} md={isButtonDelete ? 4 : 5} lg={isButtonDelete ? 4 : 5}>
                <SelectNoFormItem
                    id={props.id + "source"}
                    label={"- Define -"}
                    value={props.value2}
                    options={props.options2}
                    disabled={props.disabled}
                    onChange={(value, event) => props.onChange2 && props.onChange2(value, event)}
                />
            </Grid>
        </Grid>
    )
});

export const SelectMultipleNoFormItem = forwardRef((props: SelectNoFromProps, ref) => {
    const {
        fullWidth = true,
        limitTags = 2,
        isSelectAll = true,
    } = props;

    const [value, setValue] = useState<string[]>(props.value);

    const [t] = useTranslation();
    const getOpObjValue = (val) => {
        let res = [];
        if (val) {
            val.forEach(element => {
                res.push(props.options.find(op => op.value === element));
            });

        }
        return res;
    };

    return (
        <Autocomplete
            multiple
            disableCloseOnSelect
            ref={ref}
            id={props.id}
            disabled={props.disabled || null}
            fullWidth={fullWidth}
            size={"small"}
            options={props.options || []}
            value={getOpObjValue(value)}
            noOptionsText={props.notOptionsText || t("noInformationFound")}
            disableClearable={props.isClearable || null}
            limitTags={limitTags}
            renderOption={(props_, option, { selected }) => {
                return (
                    <li {...props_} key={option.value}>
                        <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={option.value === "All999" ? (value || []).length == (props.options || []).length : selected}
                            onChange={(e, v) => {
                                if (option.value === "All999" && (!v)) {
                                    props.onChange && props.onChange([], e);
                                    setValue([])
                                } else {
                                    let val = [];
                                    if (value) {
                                        if (e.target.checked) {
                                            let lst: any = (value || []).filter(f => f != option.value);
                                            lst.push(option.value);
                                            val = lst;
                                        } else {
                                            val = (value || []).filter(f => f != option.value)
                                        }
                                    } else {
                                        if (e.target.checked) {
                                            val.push(option.value)
                                        }
                                    }
                                    props.onChange && props.onChange(val, e);
                                }
                            }}
                        />
                        {option.label}
                    </li>
                );
            }}

            filterOptions={(options, params) => {
                const filtered = params.inputValue ? options.filter((f: any) => f.label.toLowerCase().includes(params.inputValue.toLowerCase())) : options;
                return isSelectAll ? [{ label: "Select All", value: "All999" }, ...filtered] : filtered;
            }}

            getOptionLabel={(itemOption: any) => {
                return `${itemOption?.label}`
            }}

            renderInput={(params) =>
                <TextField
                    {...params}
                    name={props.id}
                    disabled={props.disabled}
                    label={props.label}
                    size={"small"}
                    fullWidth={fullWidth}
                    sx={{
                        "label.MuiInputLabel-shrink": {
                            // backgroundColor: "rgb(255 255 255 / 18%)",
                            top: "0px",
                        },
                        ".MuiInputLabel-outlined": {
                            top: "0px",
                        },
                        ".MuiInputLabel-asterisk": {
                            color: "red"
                        }
                    }}
                />}

            onChange={(event, selectedOptions, reason) => {
                if (reason === "selectOption" || reason === "removeOption") {
                    if (selectedOptions.find(option => option.value === "All999")) {
                        if (selectedOptions.length == 1) {
                            const allSelected = props.options.length === (value || []).length;
                            if (!allSelected) {
                                setValue(props.options.map(m => m.value));
                                props.onChange && props.onChange(props.options.map(m => m.value), event);
                            } else {
                                setValue(selectedOptions.filter(f => f.value != "All999").map(m => m.value));
                                props.onChange && props.onChange(selectedOptions.filter(f => f.value != "All999").map(m => m.value), event);
                            }
                        } else {
                            setValue([]);
                            props.onChange && props.onChange([], event);
                        }

                    } else {
                        let arr = (selectedOptions || []).filter(f => f.value != "All999").map(m => m["value"]);
                        setValue(arr || []);
                        props.onChange && props.onChange(selectedOptions.filter(f => f.value != "All999"), event);
                    }
                } else if (reason === "clear") {
                    setValue([]);
                    props.onChange && props.onChange([], event);
                }

            }}

            onBlur={(event) => {
                props.onBlur && props.onBlur(event);
            }}

            onKeyPress={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}

            onKeyDown={(event) => {
                props.onKeyDown && props.onKeyDown(event);
            }}

            onKeyUp={(event) => {
                props.onKeyPress && props.onKeyPress(event);
            }}
        />
    );
});

export const SelectMultipleAddOptionsNoFormItem = forwardRef((props: SelectNoFromProps, ref) => {
    const {
        fullWidth = true,
        limitTags = 2,
        isSelectAll = true,
    } = props;

    const [value, setValue] = useState<string[]>(props.value);
    const [t] = useTranslation();
    const fixedOptions = [];
    const getOpObjValue = (val) => {
        let res = [];
        if (val) {
            val.forEach(element => {
                res.push(props.options.find(op => op.value === element));
            });

        }
        return res;
    };

    const handleToggleSelectAll = (selectedOptions) => {
        const allSelected = props.options.length === (value || []).length;
        let chkFix = (value || []).filter(f => f == fixedOptions[0]);
        let chkData = chkFix.length > 0 ? [] : fixedOptions[0] ?? []
        if (!allSelected) {
            setValue([...chkData, ...props.options.map(m => m.value)]);
            props.onChange && props.onChange(props.options, null);
        } else {
            setValue(fixedOptions);
            props.onChange && props.onChange([], null);
        }
    };

    const handleChange = (event, selectedOptions, reason) => {

        let chkFix = (value || []).filter(f => f == fixedOptions[0]);
        let chkData = chkFix.length > 0 ? [] : fixedOptions[0] ?? []
        if (reason === "selectOption" || reason === "removeOption") {
            if (selectedOptions.find(option => option?.value === "ALL999")) {
                handleToggleSelectAll(selectedOptions);
            } else if (selectedOptions.find(option => option.value === "ADD9999")) {
                props.options.push({ value: selectedOptions.find(option => option?.value === "ADD9999")["newVaue"], label: selectedOptions.find(option => option?.value === "ADD9999")["newVaue"], Isnew: true })
                let v = selectedOptions.filter(f => f?.value != "ADD9999").map(m => m["value"]);
                let o = selectedOptions.filter(f => f?.value == "ADD9999").map(m => m["newVaue"]);
                setValue([...chkData, ...v, ...o])
                props.onChange && props.onChange(selectedOptions, event);
            } else {
                setValue([...chkData, ...selectedOptions.map(m => m.value)])
                props.onChange && props.onChange(selectedOptions, event);
            }
        } else if (reason === "clear") {
            setValue(fixedOptions);
            props.onChange && props.onChange([], event);
        }
    };

    return (
        <>
            <Autocomplete
                multiple
                disableCloseOnSelect
                ref={ref}
                id={props.id}
                disabled={props.disabled || null}
                fullWidth={fullWidth}
                size={"small"}
                options={props.options || []}
                value={getOpObjValue(value)}
                noOptionsText={props.notOptionsText || t("noInformationFound")}
                disableClearable={props.isClearable || null}
                limitTags={limitTags}
                renderOption={(props_, option, { selected }) => {
                    return (
                        <li {...props_} key={option.value}>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={((value || []).length > 0 && option.value === "ALL999" && props.options.length === (value || []).length) || selected ? true : selected}
                            />
                            {option.label}
                        </li>
                    );
                }}

                getOptionLabel={(itemOption: any) => {
                    return `${itemOption?.label}`
                }}
                filterOptions={(options, params) => {
                    const filtered = filter(options, params);
                    if (params.inputValue !== '') {
                        if (props.options.filter(f => f.value == params.inputValue).length == 0) {
                            filtered.push({
                                value: "ADD9999",
                                label: `Add "${params.inputValue}"`,
                                newVaue: params.inputValue
                            });
                        }
                    }
                    return isSelectAll ? [{ label: "Select All", value: "ALL999" }, ...filtered] : filtered;
                }}
                renderInput={(params) =>
                    <TextField
                        {...params}
                        name={props.id}
                        disabled={props.disabled}
                        label={props.label}
                        size={"small"}
                        fullWidth={fullWidth}
                        sx={{
                            "label.MuiInputLabel-shrink": {
                                // backgroundColor: "rgb(255 255 255 / 18%)",
                                top: "0px",
                            },
                            ".MuiInputLabel-outlined": {
                                top: "0px",
                            },
                            ".MuiInputLabel-asterisk": {
                                color: "red"
                            }
                        }}
                    />}
                onChange={handleChange}
                onBlur={(event) => {
                    props.onBlur && props.onBlur(event);
                }}
                onKeyPress={(event) => {
                    props.onKeyPress && props.onKeyPress(event);
                }}
                onKeyDown={(event) => {
                    props.onKeyDown && props.onKeyDown(event);
                }}
                onKeyUp={(event) => {
                    props.onKeyPress && props.onKeyPress(event);
                }}

            />
        </>
    )
});

export const DeleteInTable = forwardRef((props: DeleteInTableNoFormprop, ref) => {

    return (
        <>
            {!props.isDisabled && (
                <Button id={"button-" + props.id} className={"but-" + props.id} variant="contained" color="error" style={{
                    height: "33px",
                    marginRight: "5px",
                    borderRadius: "10px",
                    minWidth: "36px",
                    boxShadow: "rgba(0, 0, 0, 0.189) 0px 5px 15px",
                    padding: "0px"
                }}
                    disabled={props.isDisabled}
                    onClick={(e) => props.onDelete && props.onDelete(e)}
                >
                    <MdDeleteForever style={{ fontSize: "24px" }} />
                </Button>
            )}

        </>

    );
});